/* eslint-disable */

import * as runtime from '../runtime';
import type {
  AddEventRegistrationResultDto,
  RegisterFamilyMemberRequestDto,
  RegisterGuestRequestDto,
  RegisterSelfRequestDto,
} from '../models';

export interface RegisterSelfRequest {
  orgSlug: string;
  eventSlug: string;
  registerSelfRequestDto: RegisterSelfRequestDto;
}

export interface RegisterFamilyMemberRequest {
  orgSlug: string;
  eventSlug: string;
  registerFamilyMemberRequestDto: RegisterFamilyMemberRequestDto;
}

export interface RegisterAsGuestRequest {
  orgSlug: string;
  eventSlug: string;
  registerGuestRequestDto: RegisterGuestRequestDto;
}

export class EventRegisterApi extends runtime.BaseAPI {

  async registerSelf(requestParameters: RegisterSelfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AddEventRegistrationResultDto> {
    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request({
      path: `/event-register/orgs/${encodeURIComponent(String(requestParameters.orgSlug))}/events/${encodeURIComponent(String(requestParameters.eventSlug))}/register-self`,
      method: 'POST',
      headers: headerParameters,
      query: {},
      body: requestParameters.registerSelfRequestDto,
    }, initOverrides);
    return response.json();
  }

  async registerFamilyMember(requestParameters: RegisterFamilyMemberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AddEventRegistrationResultDto> {
    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request({
      path: `/event-register/orgs/${encodeURIComponent(String(requestParameters.orgSlug))}/events/${encodeURIComponent(String(requestParameters.eventSlug))}/register-family`,
      method: 'POST',
      headers: headerParameters,
      query: {},
      body: requestParameters.registerFamilyMemberRequestDto,
    }, initOverrides);
    return response.json();
  }

  async registerAsGuest(requestParameters: RegisterAsGuestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AddEventRegistrationResultDto> {
    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request({
      path: `/event-register/orgs/${encodeURIComponent(String(requestParameters.orgSlug))}/events/${encodeURIComponent(String(requestParameters.eventSlug))}/register-guest`,
      method: 'POST',
      headers: headerParameters,
      query: {},
      body: requestParameters.registerGuestRequestDto,
    }, initOverrides);
    return response.json();
  }

}
